import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Home from '../pages/home/Home';
// About
import Greeting from '../pages/about/Greeting';
import Map from '../pages/about/Map';
import Intro from '../pages/about/Intro';
// Production
import Facilities from '../pages/production/Facilities';
import Process from '../pages/production/Process';
// Products
import DoubleSided from '../pages/products/DoubleSided';
import Industrial from '../pages/products/Industrial';
import Foam from '../pages/products/Foam';
// Request
import SampleRequest from '../pages/request/SampleRequest';
import QuoteRequest from '../pages/request/QuoteRequest';
// Community
import Notice from '../pages/community/Notice';
import Certification from '../pages/community/Certification';
import Orders from '../pages/community/Orders';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      
      {/* 회사소개 */}
      <Route path="/about/greeting" element={<Greeting />} />
      <Route path="/about/map" element={<Map />} />
      <Route path="/about/intro" element={<Intro />} />

      {/* 생산 */}
      <Route path="/production/facilities" element={<Facilities />} />
      <Route path="/production/process" element={<Process />} />

      {/* 제품소개 (/:subcategory 추가로 404 해결) */}
      {/* 1. 양면테이프 */}
      <Route path="/products/double-sided" element={<DoubleSided />} />
      <Route path="/products/double-sided/:subcategory" element={<DoubleSided />} />

      {/* 2. 산업용 테이프 */}
      <Route path="/products/industrial" element={<Industrial />} />
      <Route path="/products/industrial/:subcategory" element={<Industrial />} />

      {/* 3. 폼테이프 */}
      <Route path="/products/foam" element={<Foam />} />
      <Route path="/products/foam/:subcategory" element={<Foam />} />

      {/* 요청 */}
      <Route path="/request-sample" element={<SampleRequest />} />
      <Route path="/request-quote" element={<QuoteRequest />} />

      {/* 커뮤니티 */}
      <Route path="/community/notice" element={<Notice />} />
      <Route path="/community/cert" element={<Certification />} />
      <Route path="/community/orders" element={<Orders />} />

      {/* 404 에러 페이지 */}
      <Route path="*" element={<div style={{padding: '200px 0', textAlign: 'center'}}><h2>404 Not Found</h2><p>요청하신 페이지를 찾을 수 없습니다.</p></div>} />
    </Routes>
  );
};

export default AppRouter;